export const emptyPagedData = { data: [], total: 0 };

export const buildPagedDataFetched = (responseData) => {
    if(! responseData) return emptyPagedData;
    if(! responseData.length > 1) return emptyPagedData;

    return {
        data: responseData[0],
        total: responseData[1]
    }
} 